import { CtModelRouteData } from "@ctsolution/ct-framework";

/**
 * Associazione Utente ↔ CTFormTemplate.
 * List: "UserInfo_FormTemplate/List" (filtrare per UserInfo.Oid dell'utente).
 */
export const UserInfoFormTemplateRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("UserInfo_FormTemplate");
